// =============================================================================
// src/features/analytics/analytics-actor-feed-store.ts - Drill-down por ator.
//
// Ponte entre os chips de Personagens e a busca REAL no servidor: clicar num
// ator carrega o conteudo dele (recentes + top engajamento, opcionalmente
// restrito ao canal ativo) direto do Hasura — a amostra local do feed deixa
// de limitar a analise (caso Omar×Instagram: 0 na amostra, 62 no banco).
// O composition root registra o loader; sem ele (mock/offline) devolve null e
// o controller mantem o comportamento local. SRP: registro + despacho.
// =============================================================================

import type { OmarAnalyticsMention } from './analytics-types';

export interface AnalyticsActorFeedLoad {
  readonly actorSlugs: readonly string[];
  readonly relations: readonly string[];
  readonly relationPairs: readonly string[];
  readonly rawPlatforms: readonly string[];
}

type AnalyticsActorFeedLoader = (feedLoad: AnalyticsActorFeedLoad) => Promise<readonly OmarAnalyticsMention[]>;

let actorFeedLoader: AnalyticsActorFeedLoader | null = null;

/** Registrado pelo main.ts quando o Analytics live esta habilitado. */
export function setAnalyticsActorFeedLoader(loader: AnalyticsActorFeedLoader): void {
  actorFeedLoader = loader;
}

/** true quando o drill-down por servidor esta disponivel (live). */
export function analyticsActorFeedAvailable(): boolean {
  return actorFeedLoader !== null;
}

/** Busca o feed do ator; null em indisponivel/falha (controller decide o toast). */
export async function loadAnalyticsActorFeed(
  feedLoad: AnalyticsActorFeedLoad,
): Promise<readonly OmarAnalyticsMention[] | null> {
  if (!actorFeedLoader) return null;
  try {
    return await actorFeedLoader(feedLoad);
  } catch {
    return null;
  }
}

export function __resetAnalyticsActorFeedForTests(): void {
  actorFeedLoader = null;
}
